import gql from 'graphql-tag';

export default gql`
    mutation EditProppant($input: ProppantEditRequest) {
        editProppant(input: $input) {
            errors
        }
    }
`;
